// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c142e6d","453":"4303aefc","455":"8a5b78f0"}[chunkId] + ".chunk.js";
};